import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { toast } from "@krea/shared/design-system/utils/toast";

import { mutationKeyMap, queryKeyMap } from "@/features/query-client";

import { assignLenderApplication } from "../../api";
import type { IAssignLenderApplicationInput } from "../../types/lender-application";

interface IMutationInput {
  lenderCompanyId: number;
  lenderApplicationId: number;
  data: IAssignLenderApplicationInput;
}

type IMutationResult = Awaited<ReturnType<typeof assignLenderApplication>>;

export const useAssignLenderUserLenderApplicationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<IMutationResult, AxiosError, IMutationInput>({
    mutationFn: async ({ data, lenderApplicationId, lenderCompanyId }) => {
      return await assignLenderApplication(
        lenderCompanyId,
        lenderApplicationId,
        data,
      );
    },
    mutationKey: mutationKeyMap.assignLenderUserLenderApplication,
    onSuccess: (response, { lenderApplicationId }) => {
      const queryKey = queryKeyMap.getLenderApplication(lenderApplicationId);

      queryClient.setQueryData(queryKey, response);
    },
    onError: () => {
      toast.error("Failed assigning lender user to lender application");
    },
  });
};
